import { CreateEditSchedulingModal } from "./CreateEditSchedulingModal";
import { CreateEditTruckBrandModal } from "./CreateEditTruckBrandModal";
import { CreateEditTruckModelModal } from "./CreateEditTruckModelModal";

export const CreateEdit = {
  Scheduling: CreateEditSchedulingModal,
  TruckModel: CreateEditTruckModelModal,
  TruckBrand: CreateEditTruckBrandModal
};
